@if (!selectedWorkProcess) {
  <p class="selector-hint">{{ 'workProcessSelector.hint' | translate }}</p>
}

<section class="work-process-selects">
  <app-client-search
    [preselected]="selectedClient"
    (clientSelected)="onClientSelected($event)"
  ></app-client-search>

  <mat-form-field appearance="outline">
    @if (areWorkProcessesLoading) {
      <mat-icon matPrefix class="loading">hourglass_top</mat-icon>
    }
    <mat-label>{{ 'documentSummary.selectWorkProcess' | translate }}</mat-label>
    <mat-select
      required
      [(value)]="selectedWorkProcess"
      [disabled]="!selectedClient || areWorkProcessesLoading || workProcessesError"
      (selectionChange)="onWorkProcessChange()"
    >
      @for (process of workProcesses; track process.werkprocesNummer) {
        <mat-option [value]="process">
          {{ formatWorkProcessLabel(process) }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</section>

@if (workProcessesNotFound) {
  <app-inline-snackbar
    [type]="SnackbarType.INFO"
    [message]="'documentSummary.workProcessesNotFound' | translate"
    [showCloseButton]="false"
  ></app-inline-snackbar>
}

@if (workProcessesError) {
  <app-inline-snackbar
    [type]="SnackbarType.INFO"
    [message]="'documentSummary.workProcessesError' | translate"
    [showCloseButton]="false"
  ></app-inline-snackbar>
}
